import { SearchFAQs } from "./SearchFAQs";
export default SearchFAQs;
